export default {
  config: {
    setMode: false,
    clearMode: false,
    nudgeMode: false,
    menuActive: false
  },
  volatile: {
    currentVidId: "Z8nppTSY-Rs", // Fill one slot for first time users
    currentVidTitle: "",
    currentMidiInput: "",
    vidLength: 0,
    currentTime: 0,
    currentNote: "",
    pads: [
      {
        cuePoint: 0,
        note: "C"
      },
      {
        cuePoint: 0,
        note: "C#"
      },
      {
        cuePoint: 0,
        note: "D"
      },
      {
        cuePoint: 0,
        note: "D#"
      },
      {
        cuePoint: 0,
        note: "E"
      },
      {
        cuePoint: 0,
        note: "F"
      },
      {
        cuePoint: 0,
        note: "F#"
      },
      {
        cuePoint: 0,
        note: "G"
      },
      {
        cuePoint: 0,
        note: "G#"
      },
      {
        cuePoint: 0,
        note: "A"
      },
      {
        cuePoint: 0,
        note: "A#"
      },
      {
        cuePoint: 0,
        note: "B"
      }
    ],
    videos: []
  },
  memoryPads: {
    memory1: {
      nr: 1,
      active: false,
      used: false,
      content: []
    },
    memory2: {
      nr: 2,
      active: false,
      used: false,
      content: []
    },
    memory3: {
      nr: 3,
      active: false,
      used: false,
      content: []
    },
    memory4: {
      nr: 4,
      active: false,
      used: false,
      content: []
    }
  }
};
